import {
	NETWORK_ERROR_ACTION,
	SHOW_PRELOADER_ACTION,
	HIDE_PRELOADER_ACTION,
	UPDATE_MUTATION_AND_CURRENCY_ACTION
} from '../actions/UiActions';
import { INITIAL_DATA_LOADED, SUGGESTED_SHOP_DETECTED } from '../actions/CompoundFetchActions';
import CurrencyService from '../services/CurrencyService';
import MutationService from '../services/MutationService';
import Currency from '../models/Currency';
import Mutation from '../models/Mutation';
import BaseReducer from './BaseReducer';

const initialState = {
	initialized: false,
	preloader: true,
	header: 'Header',
	error: false,
	errorMsg: '',
	suggestedShopId: 11,
	currency: Currency.normalize({
		code: ''
	}),
	mutation: Mutation.normalize({
		code: ''
	}),
	defaultCurrency: Currency.normalize({
		code: ''
	}),
	defaultMutation: Mutation.normalize({
		code: ''
	})
};

export default class UiReducer extends BaseReducer {

	/**
	 * Map of normalizers
	 *
	 * @return {*}
	 */
	static get normalizers() {
		return {
			currency: Currency,
			defaultCurrency: Currency,
			mutation: Mutation,
			defaultMutation: Mutation
		};
	}

	/**
	 * @param {object} state
	 * @param {object} action
	 * @param {object} globalState
	 * @return {*}
	 */
	static reduce(state = initialState, action, globalState) {
		switch (action.type) {
			// eslint-disable-next-line no-case-declarations
			case INITIAL_DATA_LOADED:
				const mutation = MutationService.findDefaultMutation(action.mutations);
				const currency = CurrencyService.findDefaultCurrency(action.currencies, mutation.id);
				return UiReducer.normalize({
					...state,
					preloader: false,
					initialized: true,
					defaultCurrency: currency,
					defaultMutation: mutation,
					mutation,
					currency
				});
			case UPDATE_MUTATION_AND_CURRENCY_ACTION:
				return {
					...state,
					currency: CurrencyService.findCurrencyByCode(action.currency, globalState) || state.defaultCurrency,
					mutation: MutationService.findMutationByCode(action.mutation, globalState) || state.defaultMutation
				};
			case NETWORK_ERROR_ACTION:
				return {
					...state,
					error: true,
					errorMsg: action.msg
				};
			case SHOW_PRELOADER_ACTION:
				return {
					...state,
					preloader: true
				};
			case HIDE_PRELOADER_ACTION:
				return {
					...state,
					preloader: false
				};
			case SUGGESTED_SHOP_DETECTED:
				return {
					...state,
					suggestedShopId: action.shopId
				}
		}

		// For any other action, if data contains header, we set the header
		if (action.header) {
			return {
				...state,
				header: action.data.header
			};
		}
		return state;
	}
}




// WEBPACK FOOTER //
// ./reducers/UiReducer.js